
import Vue, { PropType } from "vue";

import { DialogCloseType, DialogI } from "@/types/dialog";
import UserNotesList from "@/components/userNote/UserNotesList.vue";

import BaseDialog from "@/components/dialog/BaseDialog.vue";
import Btn from "@/components/v2/base/Btn.vue";

export default Vue.extend({
  name: "NotesDialog",
  components: {
    BaseDialog,
    Btn,
    UserNotesList,
  },

  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },

  methods: {
    closeDialog() {
      this.dialog.close({
        type: DialogCloseType.CLOSED,
      });
    },
  },
});
